<div class="backgroundColor">
  <div class="fx-layout-row" fxFlexFill fxLayoutAlign="center center">
    <div fxFlex="90%" class="white">
      <div [innerHTML]="content"></div>
    </div>
  </div>
</div>
